import { initializeApp, getApps, type FirebaseApp } from "firebase/app";

let app: FirebaseApp | null = null;

// PUBLIC Firebase web config for the customer app (web-push only). These are
// NOT secrets — they're the same public values already committed in
// public/firebase-messaging-sw.js and documented in .env.example as "safe to
// commit/ship". We hardcode them as fallbacks because relying solely on
// VITE_FIREBASE_* being injected at build time was fragile: CI wasn't inlining
// them, so firebaseAppOrNull() returned null and push silently no-opped (no
// token capture, opt-in card auto-hidden). Env vars still override when set.
const PUBLIC_FIREBASE = {
  apiKey: "AIzaSyB0cvgV5dB3eQ3KaSFOKN6Xs_n4AX3Fo9M",
  projectId: "rosy-timer-453511-c0",
  messagingSenderId: "378055833376",
  appId: "1:378055833376:web:71f6ab3a63357081750945",
} as const;

// VAPID public key (Web Push certificate). Public by design — it's the public
// half of the keypair and ships in the client regardless. NOTE: this is the
// value actually deployed in the live storefront bundle; .env.example carried a
// STALE value (BKUWvo7g…) that does not match the Firebase Web Push cert.
const PUBLIC_VAPID_KEY =
  "BL0H8AlNXmNAsj4QmOLvVUzdU23bkYxujESmIV6KmLeETNCXEOLtwdNaXBsEfa7pL5bGElDn1-bP_D0p5mYi3CM";

export function getFirebaseConfig() {
  return {
    apiKey: (import.meta.env.VITE_FIREBASE_API_KEY as string | undefined) || PUBLIC_FIREBASE.apiKey,
    projectId:
      (import.meta.env.VITE_FIREBASE_PROJECT_ID as string | undefined) || PUBLIC_FIREBASE.projectId,
    messagingSenderId:
      (import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID as string | undefined) ||
      PUBLIC_FIREBASE.messagingSenderId,
    appId: (import.meta.env.VITE_FIREBASE_APP_ID as string | undefined) || PUBLIC_FIREBASE.appId,
  };
}

export function firebaseAppOrNull(): FirebaseApp | null {
  const cfg = getFirebaseConfig();
  if (!cfg.apiKey || !cfg.appId || !cfg.messagingSenderId) return null;
  if (app) return app;
  app = getApps()[0] ?? initializeApp(cfg);
  return app;
}

export function vapidKey(): string | null {
  return (import.meta.env.VITE_FIREBASE_VAPID_KEY as string | undefined) || PUBLIC_VAPID_KEY;
}
